import * as React from 'react';
import { Item } from '../../../../../../components/Grid';
import HistoryRow from '../../../../../../components/HistoryRow';
import HistoryRowControls from '../../../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../../../components/HistoryRowListing';
import { IHistoryContext } from '../../../../../../containers/FormContextHandler';
import { sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../utils/functions';

const UNHDRSHistory = ({
  documents = [],
  startEdit,
  view,
  fm = (): string => '',
}: IHistoryContext<IUHDRSDiagnosticConfidenceIndex>): React.JSX.Element => {
  const uhdrs = documents.toSorted((d1, d2) => sortPartialDate(d2.date, d1.date));
  return (
    <HistoryRow
      headerText={fm('diagnosis.huntington.uhdrs.history.header')}
      rowButton={
        startEdit
          ? newButton('uhdrsConfidenceIndex', startEdit({}, 'uhdrsConfidenceIndex'), 'general.new', 15)
          : undefined
      }
    >
      <HistoryRowListing
        documents={uhdrs}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={10}>{fm('diagnosis.huntington.uhdrs.history.index')}</Item>
          </>
        }
        contentFormat={(d: IUHDRSDiagnosticConfidenceIndex): React.JSX.Element => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {d.date && formatPartialDate(d.date)}
            </Item>
            <Item xs={7}>{d.index ? `${d.index} - ` + fm(`diagnosis.huntington.uhdrs.form.opts.${d.index}`) : ''}</Item>
            <Item xs={3}>
              {startEdit ? <HistoryRowControls document={d} startEdit={startEdit} view={view} /> : null}
            </Item>
          </>
        )}
      />
    </HistoryRow>
  );
};

export default UNHDRSHistory;
